import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { listenModalInitialized, showModal, unlistenModalInitialized } from '@phoenix/helpers/modal-helper';

export const useReference = (props) => {
  const store = useStore();

  const reference = ref(null);
  const changeReferenceModalInitialized = ref(false);

  const referenceType = computed(() => store.state.engravingToolModal.referenceType);

  const openChangeReferenceModal = (params = {}) => {
    if (changeReferenceModalInitialized.value) {
      showModal(props.selectionModalId, params);
    } else {
      const unwatch = watch(changeReferenceModalInitialized, () => {
        showModal(props.selectionModalId, params);
        unwatch();
      });
    }
  };

  const onSelectionModalInitialized = () => {
    changeReferenceModalInitialized.value = true;
  };

  watch(
    () => store.state.engravingToolModal.reference,
    (value) => {
      if (value === null) {
        return;
      }

      reference.value = value;
    },
  );

  onBeforeUnmount(() => {
    unlistenModalInitialized(props.selectionModalId, onSelectionModalInitialized);
  });

  listenModalInitialized(props.selectionModalId, onSelectionModalInitialized);

  return {
    reference,
    referenceType,
    openChangeReferenceModal,
  };
};
